<template>
  <div class="container mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <div>
        
        <h1 v-if="!vendorId" class="title">Purchase Orders</h1>
        <h1 v-if="vendorId" class="title is-size-4">{{vendorName}} POs</h1>

        <nav class="panel my-panel">
          <div class="select is-pulled-right mt-2 mr-2">
            <select v-model="timeFilter">
              <option>Within a year</option>
              <option>All</option>
            </select>
          </div>
          <p class="panel-heading">Summary
            
          </p>
          <a class="panel-block my-panel-row" v-if="!isVendor" :class="{'is-active': statusTypeFilter == 'Pending Approval POs'}" @click="statusTypeFilter = 'Pending Approval POs'">
            <span class="panel-icon">
              <i class="fas fa-tag" aria-hidden="true"></i>
            </span>
            <span>Pending Approval POs</span>
            <span class="my-panel-right">{{ statusTypeCounts['Pending Approval POs'] }}</span>
          </a>
          <a class="panel-block my-panel-row" :class="{'is-active': statusTypeFilter == 'New POs'}" @click="statusTypeFilter = 'New POs'">
            <span class="panel-icon">
              <i class="fas fa-tag" aria-hidden="true"></i>
            </span>
            <span>New POs</span>
            <span class="my-panel-right">{{ statusTypeCounts['New POs'] }}</span>
          </a>
          <a class="panel-block my-panel-row" :class="{'is-active': statusTypeFilter == 'Open POs'}" @click="statusTypeFilter = 'Open POs'">
            <span class="panel-icon">
              <i class="fas fa-tag" aria-hidden="true"></i>
            </span>
            <span>Open POs</span>
            <span class="my-panel-right">{{ statusTypeCounts['Open POs'] }}</span>
          </a>
          <a class="panel-block my-panel-row" :class="{'is-active': statusTypeFilter == 'Shipped POs'}" @click="statusTypeFilter = 'Shipped POs'">
            <span class="panel-icon">
              <i class="fas fa-tag" aria-hidden="true"></i>
            </span>
            <span>Shipped POs</span>
            <span class="my-panel-right">{{ statusTypeCounts['Shipped POs'] }}</span>
          </a>
          <a class="panel-block my-panel-row" :class="{'is-active': statusTypeFilter == 'Received POs'}" @click="statusTypeFilter = 'Received POs'">
            <span class="panel-icon">
              <i class="fas fa-tag" aria-hidden="true"></i>
            </span>
            <span>Received POs</span>
            <span class="my-panel-right">{{ statusTypeCounts['Received POs'] }}</span>
          </a>
          <a class="panel-block my-panel-row" :class="{'is-active': statusTypeFilter == 'Unknown'}" @click="statusTypeFilter = 'Unknown'" v-if="statusTypeCounts['Unknown']">
            <span class="panel-icon">
              <i class="fas fa-tag" aria-hidden="true"></i>
            </span>
            <span>Unknown POs</span>
            <span class="my-panel-right">{{ statusTypeCounts['Unknown'] }}</span>
          </a>
          <a class="panel-block my-panel-row" :class="{'is-active': statusTypeFilter == 'All POs'}" @click="statusTypeFilter = 'All POs'">
            <span class="panel-icon">
              <i class="fas fa-tag" aria-hidden="true"></i>
            </span>
            <span>All POs</span>
            <span class="my-panel-right">{{ statusTypeCounts['All POs'] }}</span>
          </a>
        </nav>

        <div class="mt-3">
          <div v-if="waiting">
            <span class="icon is-medium is-size-4">
              <i class="fas fa-spinner fa-pulse"></i>
            </span>
          </div>
          <div v-else>
            <div class="columns mt-4">
              <div class="column field mb-0 pb-0">
                <p class="control has-icons-left">
                  <span class="select">
                    <select v-model="timeFilter" disabled>
                      <option>Within a year</option>
                      <option>All</option>
                    </select>
                  </span>
                  <span class="icon is-small is-left">
                    <i class="fas fa-filter"></i>
                  </span>
                  <a class="button ml-3" :class="{'is-loading': exporting}" @click="exportPOs">Export POs</a>
                </p>
              </div>
              <div class="column field  mb-0 pb-0">
                <p class="control has-icons-left">
                  <input class="input" type="text" placeholder="Search" v-model="search">
                  <span class="icon is-small is-left">
                    <i class="fas fa-search"></i>
                  </span>
                </p>
              </div>
            </div>

            <div class="table-container">
            <table class="table is-fullwidth my-table">
              <thead>
                <th>
                  <span class="is-clickable" @click="changeSortOption('id')">Id</span>
                  <span class="icon" v-if="sortOption.field == 'id'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('tranId')">PO#</span>
                  <span class="icon" v-if="sortOption.field == 'tranId'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('subsidiaryName')">Subsidiary</span>
                  <span class="icon" v-if="sortOption.field == 'subsidiaryName'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span><br/>
                  <div class="field header-select">
                    <div class="control">
                      <div class="select">
                        <select v-model="filters.subsidiary.selected">
                          <option v-for="(vo, i) in filters.subsidiary.options" :value="vo" :key="'so-'+i">{{vo}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('locationName')">Location</span>
                  <span class="icon" v-if="sortOption.field == 'locationName'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span><br/>
                  <div class="field header-select">
                    <div class="control">
                      <div class="select">
                        <select v-model="filters.location.selected">
                          <option v-for="(vo, i) in filters.location.options" :value="vo" :key="'lo-'+i">{{vo}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </th>
                <th v-if="!vendorId">
                  <span class="is-clickable" @click="changeSortOption('vendorName')">Vendor</span>
                  <span class="icon" v-if="sortOption.field == 'vendorName'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span><br/>
                  <div class="field header-select">
                    <div class="control">
                      <div class="select">
                        <select v-model="filters.vendor.selected">
                          <option v-for="(vo, i) in filters.vendor.options" :value="vo" :key="'vo-'+i">{{vo}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('statusType')">Type</span>
                  <span class="icon" v-if="sortOption.field == 'statusType'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('statusId')">Status</span>
                  <span class="icon" v-if="sortOption.field == 'statusId'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span><br/>
                  <div class="field header-select">
                    <div class="control">
                      <div class="select">
                        <select v-model="filters.status.selected">
                          <option v-for="(vo, i) in filters.status.options" :value="vo" :key="'sto-'+i">{{vo}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('memo')">Memo</span>
                  <span class="icon" v-if="sortOption.field == 'memo'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('lastModifiedDate')">Modified at</span>
                  <span class="icon" v-if="sortOption.field == 'lastModifiedDate'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
              </thead>
              <tbody>
                <template v-for="(p, i) in showingPos">
                  <tr>
                    <td class="id-cell" @click="toggleOpen(p)">
                      <i class="fas" :class="{'fa-angle-right': !p.opened, 'fa-angle-down': p.opened,}"></i>&nbsp;
                      <span>{{p.id}}</span>
                    </td>
                    <td>
                      <router-link :to="vendorId ? '/vendor-purchase-order/' + vendorId + '/' + p.id : '/purchase-order/' + p.id">{{p.tranId}}</router-link>
                    </td>
                    <td>{{p.subsidiaryName}}</td>
                    <td>{{p.locationName}}</td>
                    <td v-if="!vendorId">{{p.vendorName}}</td>
                    <td>
                      <span :class="'tag ' + getStatusTypeTag(p.statusType)">{{p.statusType}}</span>
                    </td>
                    <td>
                      <span :class="'tag ' + getStatusTag(p.statusId)">{{p.statusId}}</span>
                    </td>
                    <td class="memo-cell">{{p.memo}}</td>
                    <td>{{p.lastModifiedDate}}</td>
                  </tr>
                  <tr v-if="p.opened">
                    <td>
                      <button class="button">
                        <span class="icon">
                          <i class="fas fa-download" @click="exportItems(p)"></i>
                        </span>
                      </button>
                    </td>
                    <td :colspan="vendorId ? 7 : 9">
                      <span v-if="!p.items" class="icon is-medium is-size-6">
                        <i class="fas fa-spinner fa-pulse"></i>
                      </span>
                      <table v-if="p.items && p.totals" class="table is-narrow is-hoverable sub-items-table">
                        <thead>
                          <th>Line</th>
                          <th>NS id</th>
                          <th>Item</th>
                          <th class="num-cell">Remaining Qty</th>
                          <th class="num-cell">Unit price</th>
                          <th class="num-cell">PO Qty</th>
                          <th class="num-cell">Total price</th>
                          <th class="num-cell">Tarriff %</th>
                          <th class="num-cell">Tarriff total</th>
                          <th>Inbound</th>  
                        </thead>
                        <tbody>
                          <tr v-for="(pi, i) in p.items" :key="'p-' + p.id + '-i-' + i">
                            <td>{{ pi.line }}</td>
                            <td>{{ pi.itemId }}</td>
                            <td>{{ pi.itemName }}</td>
                            <td class="num-cell">{{ pi.quantityAvailable }}</td>
                            <td class="num-cell">{{ formatPrice(pi.rate) }}</td>
                            <td class="num-cell">{{ pi.quantity }}</td>
                            <td class="num-cell">{{ formatPrice(pi.rate * pi.quantity) }}</td>
                            <td class="num-cell">{{ pi.tarriff == null ? 'N/A' : ('' + pi.tarriff + '%') }}</td>
                            <td class="num-cell">{{ pi.tarriff == null ? 'N/A' : (formatPrice(pi.rate * pi.quantity * pi.tarriff / 100)) }}</td>
                            <td>
                              <div v-for="(ib, j) in pi.inbounds" :key="'ibi-'+i+'-'+j">
                                <router-link v-if="ib" :to="vendorId ? ('/vendor-inbound/' + vendorId + '/' + ib.inbound.id) : ('/inbound/' + ib.inbound.id)">
                                  {{ib.inbound.shipmentNumber + ' ' + ib.inbound.bookingId }}
                                </router-link>&nbsp;
                                <span>{{ ib.inboundItem.quantityExpected }}</span>&nbsp;
                                <span>{{ ib.inboundItem.containerInfo }}</span>&nbsp;
                                <span>{{ ib.inbound.expectedDeliveryDate }}</span>&nbsp;
                                <span>{{ ib.inbound.shipmentStatus }}</span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <th>Total</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th class="num-cell">{{ p.totals.quantity || '' }}</th>
                            <th class="num-cell">{{ p.totals.amount ? formatPrice(p.totals.amount) : '' }}</th>
                            <th></th>
                            <th class="num-cell">{{ p.totals.tarriff ? formatPrice(p.totals.tarriff) : '' }}</th>
                            <th></th>
                          </tr>
                        </tfoot>
                      </table>
                    </td>
                  </tr>
                </template>
                
              </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>

    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import router from '../router'

export default {
  name: 'PurchaseOrders',
  components: {
  },
  data () {
    return {
      error: '',
      waiting: false,
      search: '',
      timeFilter: 'Within a year',
      pos: [],
      sortOption: { field: 'lastModifiedDate', asc: false },
      search: '',
      filters: {
        subsidiary: {options: [], selected: 'All'},
        location: {options: [], selected: 'All'},
        vendor: {options: [], selected: 'All'},
        approval: {options: [], selected: 'All'},
        status: {options: [], selected: 'All'},
      },
      statusTypeFilter: 'All POs',
      exporting: false,
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    isVendor () {
      return this.$store.state.user.groups.includes('Vendors')
    },
    vendorId () {
      return this.$route.params.vendorId
    },
    vendorName () {
      var myVendors = this.$store.state.config.myVendors
      for (var v of myVendors) {
        if (v.nsId == this.vendorId) {
          return v.entityId + ' ' + v.companyName
        }
      }
      return ''
    },
    showingPos () {
      var vm = this
      var timeFilteredPos = vm.pos.filter(p => {
        if (vm.timeFilter == 'All') {
          return true
        }
        var now = new Date()
        var created = new Date(p.createdDate || p.tranDate)
        var diff = now.getTime() - created.getTime()
        return diff < 365 * 24 * 2400 * 1000
      })
      var search = vm.search.trim().toLowerCase()
      var filteredPos = timeFilteredPos.filter(p => {
        return (p.tranId.toLowerCase().includes(search) || p.subsidiaryName.toLowerCase().includes(search)
          || p.locationName.toLowerCase().includes(search) || p.vendorName.toLowerCase().includes(search) || p.memo.toLowerCase().includes(search))
          && (vm.statusTypeFilter == 'All POs' || p.statusType == vm.statusTypeFilter)
      })

      filteredPos = filteredPos.filter(p => 
        (this.filters.subsidiary.selected == 'All' || this.filters.subsidiary.selected == p.subsidiaryName)
        && (this.filters.location.selected == 'All' || this.filters.location.selected == p.locationName)
        && (this.filters.vendor.selected == 'All' || this.filters.vendor.selected == p.vendorName)
        && (this.filters.approval.selected == 'All' || this.filters.approval.selected == p.approvalStatusName)
        && (this.filters.status.selected == 'All' || this.filters.status.selected == p.statusId)
      )
      
      var sort = vm.sortOption
      var sortedPos = filteredPos.sort((a, b) => {
        var va = a[sort.field]
        var vb = b[sort.field]
        if (va == null || vb == null) {
          if (va) {
            return sort.asc ? 1 : -1
          }
          if (vb) {
            return sort.asc ? -1 : 1
          }
          return 0
        }
        if (sort.field == 'id' ) {
          return sort.asc ? va - vb : vb - va
        }
        return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      return sortedPos
    },
    statusTypeCounts () {
      var vm = this
      var timeFilteredPos = vm.pos.filter(p => {
        if (vm.timeFilter == 'All') {
          return true
        }
        var now = new Date()
        var created = new Date(p.createdDate || p.tranDate)
        var diff = now.getTime() - created.getTime()
        return diff < 365 * 24 * 2400 * 1000
      })
      return vm.collectStatusTypeCounts(timeFilteredPos)
    },
  },
  watch: {
    vendorId: function (val) {
      if (val) {
        this.getVendorPos()
      } else {
        this.getAllPos()
      }
    },
  },
  methods: {
    getAllPos () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-all-purchase-orders/').then(resp => {
        this.pos = resp.body.map(p => {
          p.opened = false
          p.items = null
          p.totals = null
          p.statusType = this.makeStatusType(p)
          return p
        })
        this.collectFiltersOptions()
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    getVendorPos () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-vendor-purchase-orders/' + this.vendorId).then(resp => {
        this.pos = resp.body.map(p => {
          p.opened = false
          p.items = null
          p.totals = null
          p.statusType = this.makeStatusType(p)
          return p
        })
        this.collectFiltersOptions()
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    collectFiltersOptions () {
      var filters = {
        subsidiary: {options: this.collectOptions('subsidiaryName'), selected: 'All'},
        location: {options: this.collectOptions('locationName'), selected: 'All'},
        vendor: {options: this.collectOptions('vendorName'), selected: 'All'},
        approval: {options: this.collectOptions('approvalStatusName'), selected: 'All'},
        status: {options: this.collectOptions('statusId'), selected: 'All'},
      }
      this.filters = filters
    },
    collectOptions(fieldName) {
      var values = new Set()
      for (var c of this.pos) {
        values.add(c[fieldName].trim())
      }
      var vs = Array.from(values)
      vs.sort()
      vs.unshift('All')
      return vs
    },
    toggleOpen (p) {
      p.opened = !p.opened
      if (!p.items) {
        this.$http.get(this.server + '/myapp/get-purchase-order-items-with-inbounds/' + p.id).then(resp => {
          p.items = resp.body.map(pi => {
            if (p.locationId == 9) {
              pi.tarriff = pi.dutyPercentageCanada
            } else {
              pi.tarriff = pi.dutyPercentage
            }
            return pi
          })
          p.totals = this.computeTotals(p.items)
        })
      }
    },
    computeTotals (items) {
      var totals = {
        quantity: 0,
        amount: 0,
        tarriff: 0,
      }
      for (var item of items) {
        totals.quantity += item.quantity
        totals.amount += item.amount
        totals.tarriff += item.tarriff ? 0 : (item.amount * item.tarriff / 100)
      }
      return totals
    },
    changeSortOption (field) {
      this.sortOption = {
        field: field,
        asc: field == this.sortOption.field ? !this.sortOption.asc : true
      }
    },
    getStatusTag (status) {
      if (status == 'Pending Supervisor Approval') {
        return 'is-light'
      }
      if (status == 'Approved by Supervisor/Pending Receipt') {
        return 'is-warning'
      }
      if (status == 'Approved by Supervisor/Pending Bill') {
        return 'is-info'
      }
      if (status == 'Pending Bill') {
        return 'is-info'
      }
      if (status == 'Pending Billing/Partially Received') {
        return 'is-info'
      }
      if (status == 'Partially Received') {
        return 'is-info'
      }
      if (status == 'Fully Billed') {
        return 'is-success'
      }
      if (status == 'Closed') {
        return 'is-dark'
      }
      return 'is-danger'
    },
    getStatusTypeTag (t) {
      if (t == 'Pending Approval POs') {
        return 'is-light'
      }
      if (t == 'New POs') {
        return 'is-danger'
      }
      if (t == 'Open POs') {
        return 'is-warning'
      }
      if (t == 'Shipped POs') {
        return 'is-info'
      }
      if (t == 'Received POs') {
        return 'is-success'
      }
      return 'is-danger'
    },
    getApprovalStatusTag (status) {
      if (status == 'Pending Approval') {
        return 'is-warning'
      }
      if (status == 'Approved') {
        return 'is-success'
      }
      return 'is-danger'
    },
    formatPrice (value) {
      if (!value) {
        return ''
      }
      return '$' + value.toLocaleString('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: false
      })
    },
    makeStatusType (po) {
      if (po.statusId == 'Pending Supervisor Approval') {
        return 'Pending Approval POs'
      }
      if (po.statusId == 'Approved by Supervisor/Pending Receipt' && !po.confirmedBy) {
        return 'New POs'
      }
      if ((po.statusId == 'Approved by Supervisor/Pending Receipt' && po.confirmedBy) || po.statusId == 'Partially Received') {
        return 'Open POs'
      }
      if (po.statusId == 'Pending Billing/Partially Received') {
        return 'Shipped POs'
      }
      if (po.statusId == 'Approved by Supervisor/Pending Bill' || po.statusId == 'Fully Billed' || po.statusId == 'Pending Bill' || po.statusId == 'Closed' ) {
        return 'Received POs'
      }
      return 'Unknown'
    },
    collectStatusTypeCounts (pos) {
      var counts = {
        'Pending Approval POs': 0,
        'New POs': 0,
        'Open POs': 0,
        'Shipped POs': 0,
        'Received POs': 0,
        'Unknown': 0,
        'All POs': 0,
      }
      pos.forEach(po => {
        counts[po.statusType] += 1
        counts['All POs'] += 1 
      })
      return counts
    },
    exportItems (po) {
      var tranId = po.tranId
      var rows = po.items.map(item => {
        var row = [tranId, item.line.toString(), item.itemId, item.itemName, item.description, item.rate.toString(), item.quantity.toString()]
        return row.join('\t')
      })
      var header = 'PO\tLine\tNS Id\tName\tDescription\tUnit Price\tPO Quantity'
      rows.unshift(header)
      var string = rows.join('\r\n')
      console.log(string)
      var blob = new Blob([string], {type: 'text/plain;charset=utf-8'})
      saveAs(blob, tranId + '.tsv')
    },
    exportPOs () {
      this.exporting = true
      var poIds = this.showingPos.map(p => p.id)
      this.$http.post(this.server + '/myapp/export-purchase-orders/', poIds).then(resp => {
        var blob = new Blob([resp.body.content], {type: 'text/plain;charset=utf-8'})
        saveAs(blob, 'purchase-orders.tsv')
        this.exporting = false
      }, err => {
        this.error = err.body
        this.exporting = false
      })
    },
  },
  mounted () {
    if (this.vendorId) {
      this.getVendorPos()
    } else {
      this.getAllPos()
    }
  },
}
</script>

<style scoped>
.id-cell {
  min-width: 80px;
  cursor: pointer;
}
.sub-items-table {
  font-size: 0.9em;
}
.num-cell {
  text-align: right !important;
}
.memo-cell {
  word-break: break-all;
}
.header-select {
  max-width: 120px;
}
.my-panel {
  width: 360px;
}
.my-panel-row {
  position: relative;
}
.my-panel-right {
  position: absolute;
  right: 12px;
}
</style>
